export default __webpack_public_path__ + "static/media/cpp.3eb81f98.png";